import React from 'react';
import MuxPlayer from '@mux/mux-player-react';
import './Support.css';

const Support = () => {
    // TODO: Replace these placeholder IDs with your actual Mux Playback IDs
    // After uploading your videos to Mux, you'll get a Playback ID for each video
    const supports = [
        {
            playbackId: '2asDZ42NZQ2A7coIky01czC98HJyNc4fC9j5RYSSBsXE', // Replace with actual Mux Playback ID
            caption: 'KEINEMUSIK playing "Jealousy" at Pacha Ibiza'
        },
        {
            playbackId: 'YXNzisJ33vGZi48jN2pKQsEmk00ZpeSlT1JKLlJZo8300', // Replace with actual Mux Playback ID
            caption: '&Me playing "Jealousy" in Albania'
        },
        {
            playbackId: 'Qs00haDbC7ecT00iT4DyQPyK2OhEAvZuKjULrn6LUmjf4', // Replace with actual Mux Playback ID
            caption: 'Rampa and &Me playing "Jealousy" in Stockholm Sweden'
        },
        {
            playbackId: 'sprDKLX5DY6AeVMJvmdaigROBsI01GNZ1bO2VZPwZHes', // Replace with actual Mux Playback ID
            caption: 'Rampa and &Me playing "isaka" in Portugal'
        }
    ];

    const scrollRef = React.useRef(null);

    const scroll = (direction) => {
        if (scrollRef.current) {
            const { current } = scrollRef;
            const scrollAmount = 300;

            if (direction === 'left') {
                if (current.scrollLeft <= 5) {
                    current.scrollTo({ left: current.scrollWidth, behavior: 'smooth' });
                } else {
                    current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
                }
            } else {
                if (current.scrollLeft + current.clientWidth >= current.scrollWidth - 5) {
                    current.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                }
            }
        }
    };

    return (
        <section className="support-section">
            <h2>SUPPORT</h2>

            <div className="support-carousel-container">
                <button
                    className="support-scroll-btn support-scroll-left"
                    onClick={() => scroll('left')}
                    aria-label="Scroll left"
                >
                    &#10094;
                </button>

                <div className="support-grid" ref={scrollRef}>
                    {supports.map((item, index) => (
                        <div key={index} className="support-item">
                            <div className="mux-video-wrapper">
                                <MuxPlayer
                                    playbackId={item.playbackId}
                                    streamType="on-demand"
                                    muted
                                    playsInline
                                    className="support-video"
                                    style={{
                                        aspectRatio: '9/16',
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }}
                                />
                            </div>
                            <p className="support-caption">{item.caption}</p>
                        </div>
                    ))}
                </div>

                <button
                    className="support-scroll-btn support-scroll-right"
                    onClick={() => scroll('right')}
                    aria-label="Scroll right"
                >
                    &#10095;
                </button>
            </div>
        </section>
    );
};

export default Support;
